import React, { useState, useEffect } from "react";
import style from "./style.module.scss";
import HiddenDataTable from "../../../../../../components/HiddenDataTable";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import Filter from "../../../../../../assets/svg/icons/common/Filter";
import Download from "../../../../../../assets/svg/icons/common/Download";
import Table from "../../../../../../components/Table";
import Pagination from "../../../../../../components/Pagination/Pagination";
import useCommonStore from "../../../../../../stores/common";
import useMerchantStore from "../../../../../../stores/merchant";
import {
  getMerchantChargebackData,
  getMerchantChargebackDataExport,
} from "../../../../../../../api";
import MonthPicker from "../../../../../../components/MonthPicker/Index";
import { getFullMonthName } from "../../../../../../../components/helper/helper";
import CaretRight from "../../../../../../assets/svg/icons/common/CaretRight";
import ChargebackDataTable from "./table";
import Spinner from "../../../../../../components/Loaders/Spinner";
import { toast } from "react-hot-toast";

function Chargebacks() {
  const expandDetails = useCommonStore((state) => state.expandDetails);
  const activeApp = useMerchantStore((state) => state.activeApp);
  const [chargebackData, setChargebackData] = useState([]);
  const [data, setData] = useState([]);
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    perPage: 10,
  });

  const startDate = useCommonStore((state) => state.dateRange.startDate);
  const endDate = useCommonStore((state) => state.dateRange.endDate);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    const response = await getMerchantChargebackData({
      powerapp_id: activeApp?.id,
      // month: month,
      // year: year,
      start_date: startDate,
      end_date: endDate,
      page: pagination.currentPage,
    });

    if (response?.status && response?.data) {
      // Transform the paginated data
      const { data, current_page, last_page, total, per_page } = response.data;

      // Map the data to match the table columns
      const transformedData = data.map((item) => ({
        drop_down: "",
        card: item.card_number || "",
        auth_number: item.authorization_number || "",
        cb_amount: item.chargeback_amount || 0,
        cb_date: item.chargeback_date || "",
        last_action: item.chargeback_action || "",
        age: item.days_old || 0,
        to_rebut: item.days_to_rebut || 0,
        reason: item.chargeback_description || "",
        represented: item.represent || false,
      }));

      setData(data);

      setChargebackData(transformedData);
      setPagination({
        currentPage: current_page,
        totalPages: last_page,
        totalItems: total,
        perPage: per_page,
      });
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [activeApp?.id, startDate, endDate, pagination.currentPage]);

  const onChangeFilter = (data) => {
    setYear(data.year);
    setMonth(getFullMonthName(data.month));
  };

  const handlePageChange = ({ selected }) => {
    setPagination((prev) => ({ ...prev, currentPage: selected + 1 }));
  };

  const onExportClickHandler = async () => {
    if (!activeApp?.id) {
      return;
    }
    setIsExporting(true);
    try {
      const response = await getMerchantChargebackDataExport({
        powerapp_id: activeApp.id,
        start_date: startDate,
        end_date: endDate,
        export: true,
      });
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const fileName = `chargeback-${startDate}-to-${endDate}.csv`;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success("CSV downloaded successfully");
    } catch (error) {
      console.log({ error });
      toast.error("Failed to download CSV");
    }
    setIsExporting(false);
  };

  return (
    <>
      {!expandDetails && (
        <div className={style.container}>
          <HiddenDataTable />
        </div>
      )}

      {expandDetails && (
        <div className={style.container}>
          <header className={style.header}>
            <div className={style.left}>
              <h5>Chargeback details</h5>
              <ButtonIcon textColor="#254FE2">Expand All</ButtonIcon>
            </div>
            <div className={style.right}>
              <ButtonIcon
                bgColor={"#EDEDF4"}
                onClick={onExportClickHandler}
                disabled={isExporting || !activeApp?.id}
              >
                <Download />
                <span>{isExporting ? "Downloading..." : "Download"}</span>
              </ButtonIcon>
            </div>
          </header>

          <div className={style.body}>
            <ChargebackDataTable data={data} loading={loading} />
          </div>

          {!loading && pagination.totalPages > 1 && (
            <footer className={style.footer}>
              <Pagination
                pageCount={pagination.totalPages}
                currentPage={pagination.currentPage - 1}
                onPageChange={handlePageChange}
                totalItems={pagination.totalItems}
                itemsPerPage={pagination.perPage}
              />
            </footer>
          )}
        </div>
      )}
    </>
  );
}

export default Chargebacks;
